// Label sets for the embeddable calculator (/embed/calculator?lang=...).
// English is the widget default, so only el and tr are listed here.
export const EMBED_LABELS = {
  el: {
    cardTitle: 'Υπολογιστής Απόδοσης Οχήματος',
    subtitle: (n) => `Πραγματικά δεδομένα από ${n} μάρκες • 14.210 κινητήρες • 13.164 εγγραφές απόδοσης`,
    step1: '1. Επιλέξτε Μάρκα *',
    step2: '2. Επιλέξτε Μοντέλο *',
    step3: '3. Επιλέξτε Έτος/Γενιά *',
    step4: '4. Επιλέξτε Κινητήρα *',
    chooseBrand: 'Επιλέξτε μάρκα',
    loadingBrands: 'Φόρτωση μαρκών...',
    chooseModel: 'Επιλέξτε μοντέλο',
    selectBrandFirst: 'Επιλέξτε πρώτα μάρκα',
    noModels: 'Δεν βρέθηκαν μοντέλα',
    chooseYear: 'Επιλέξτε έτος',
    selectModelFirst: 'Επιλέξτε πρώτα μοντέλο',
    noGenerations: 'Δεν βρέθηκαν γενιές',
    chooseEngine: 'Επιλέξτε κινητήρα',
    selectGenFirst: 'Επιλέξτε πρώτα γενιά',
    noEngines: 'Δεν βρέθηκαν κινητήρες',
    selectedLine: 'Επιλογή',
    calculate: 'Υπολογισμός Κέρδους Απόδοσης',
    loading: 'Φόρτωση δεδομένων...',
    techSpecs: 'Τεχνικά Χαρακτηριστικά',
    stage1Gains: 'Κέρδος Απόδοσης Stage 1',
    stockPerf: 'Απόδοση Σειράς (Stock)',
    stage1Tuned: 'Μετά το Stage 1',
    power: 'Ισχύς',
    torque: 'Ροπή',
    powerGain: 'Κέρδος Ισχύος',
    torqueGain: 'Κέρδος Ροπής',
    powerIncrease: 'Αύξηση Ισχύος',
    torqueIncrease: 'Αύξηση Ροπής',
    gain: 'Κέρδος',
    book: 'Αίτημα Προσφοράς με Email',
    quote: 'Προσφορά στο WhatsApp',
    another: '← Υπολογισμός Άλλου Οχήματος',
    fuelType: 'Καύσιμο',
    method: 'Μέθοδος',
    tuningType: 'Τύπος Tuning',
    cylinderContent: 'Κυβισμός',
    compressionRatio: 'Σχέση Συμπίεσης',
    boreStroke: 'Διάμετρος x Διαδρομή',
    engineNumber: 'Κωδικός Κινητήρα',
    engineEcu: 'ECU Κινητήρα',
    selectEngineFirst: 'Επιλέξτε πρώτα κινητήρα',
    loadErrorTitle: 'Δεν ήταν δυνατή η φόρτωση δεδομένων',
    loadErrorMsg: 'Ελέγξτε τη σύνδεσή σας και δοκιμάστε ξανά.',
    retry: 'Επανάληψη',
    perfErrorMsg: 'Δεν υπάρχουν δεδομένα απόδοσης για αυτόν τον κινητήρα. Επικοινωνήστε μαζί μας για προσφορά.',
    poweredBy: 'Με την τεχνολογία της Powerlab Works',
    mailSubject: 'Αίτημα προσφοράς Stage 1',
    mailBody: (v) => `Γεια σας, ενδιαφέρομαι για Stage 1 για το όχημά μου: ${v}`,
    waText: (v) => `Γεια σας, ενδιαφέρομαι για Stage 1 για το ${v}`,
    waGeneric: 'Γεια σας, θα ήθελα πληροφορίες για chip tuning',
  },
  tr: {
    cardTitle: 'Araç Performans Hesaplayıcı',
    subtitle: (n) => `${n} marka • 14.210 motor • 13.164 performans kaydı`,
    step1: '1. Marka Seçin *',
    step2: '2. Model Seçin *',
    step3: '3. Yıl / Nesil Seçin *',
    step4: '4. Motor Seçin *',
    chooseBrand: 'Marka seçin',
    loadingBrands: 'Markalar yükleniyor...',
    chooseModel: 'Model seçin',
    selectBrandFirst: 'Önce marka seçin',
    noModels: 'Model bulunamadı',
    chooseYear: 'Yıl seçin',
    selectModelFirst: 'Önce model seçin',
    noGenerations: 'Nesil bulunamadı',
    chooseEngine: 'Motor seçin',
    selectGenFirst: 'Önce nesil seçin',
    noEngines: 'Motor bulunamadı',
    selectedLine: 'Seçim',
    calculate: 'Performans Kazancını Hesapla',
    loading: 'Performans verisi yükleniyor...',
    techSpecs: 'Teknik Özellikler',
    stage1Gains: 'Stage 1 Performans Kazançları',
    stockPerf: 'Orijinal Performans',
    stage1Tuned: 'Stage 1 Tuned',
    power: 'Güç',
    torque: 'Tork',
    powerGain: 'Güç Kazancı',
    torqueGain: 'Tork Kazancı',
    powerIncrease: 'Güç Artışı',
    torqueIncrease: 'Tork Artışı',
    gain: 'Kazanç',
    book: 'E-posta ile Teklif İste',
    quote: "WhatsApp'tan Teklif Al",
    another: '← Başka Araç Hesapla',
    fuelType: 'Yakıt Tipi',
    method: 'Yöntem',
    tuningType: 'Tuning Tipi',
    cylinderContent: 'Silindir Hacmi',
    compressionRatio: 'Sıkıştırma Oranı',
    boreStroke: 'Çap X Strok',
    engineNumber: 'Motor Numarası',
    engineEcu: 'Motor ECU',
    selectEngineFirst: 'Lütfen önce motor seçin',
    loadErrorTitle: 'Araç verisi yüklenemedi',
    loadErrorMsg: 'İnternet bağlantınızı kontrol edip tekrar deneyin.',
    retry: 'Tekrar dene',
    perfErrorMsg: 'Bu motor için performans verisi yok. Teklif için bizimle iletişime geçin.',
    poweredBy: 'Powerlab Works altyapısıyla',
    mailSubject: 'Stage 1 teklif talebi',
    mailBody: (v) => `Merhaba, aracım için Stage 1 ile ilgileniyorum: ${v}`,
    waText: (v) => `Merhaba, ${v} için Stage 1 ile ilgileniyorum`,
    waGeneric: 'Merhaba, chip tuning hakkında bilgi almak istiyorum',
  },
  en: {
    poweredBy: 'Powered by Powerlab Works',
    mailSubject: 'Stage 1 quote request',
    mailBody: (v) => `Hello, I am interested in Stage 1 for my vehicle: ${v}`,
    waText: (v) => `Hello, I am interested in Stage 1 for my ${v}`,
    waGeneric: 'Hello, I would like to know more about chip tuning',
    perfErrorMsg: 'No performance data for this engine. Contact us for a quote.',
  },
};
